<template>
  <div id="navbar" class="navvy-normal fixed-top" v-bind:class="{ 'navvy': navbarWatcher }">
    <b-navbar toggleable="md" type="dark">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="#">
        <p class="icon">
          <img src="../../assets/GetAGeekLogo.png" width="250" />
        </p>

      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item>
            <span style="color: white;">Welcome, {{LoggedInUser}}</span>
          </b-nav-item>
          <b-nav-item>
            <span class="red" @click="logout">Logout</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!--Hidden Modal for user registration -->
    <b-modal ref="registrationModal" v-model="registered" hide-footer title="Please enter your username and PC Asset Number">
      <div class="d-block text-center">
        <b-input-group class="mb-2" prepend="name">
          <b-form-input ref="name"></b-form-input>
        </b-input-group>
        <b-input-group class="mb-2" prepend="Username">
          <b-form-input ref="username"></b-form-input>
        </b-input-group>
        <b-input-group prepend="PC Asset Number?">
          <b-form-input ref="asset"></b-form-input>
        </b-input-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "NavBar",
  props: { title: "", user: "" },
  data() {
    return {
      //Change navbar class if scroll > 200
      registered: false,
      navbarWatcher: false
    };
  },
  computed: {
    LoggedInUser: function() {
      return firebase.auth().currentUser.email;
    }
  },

  methods: {
    scrollWatcher() {
      this.navbarWatcher =
        document.documentElement.scrollTop > 100 ||
        document.body.scrollTop > 100; //THis is for Mobile
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ location: "/login" });
        });
    }
  },
  created() {
    window.addEventListener("scroll", this.scrollWatcher, { passive: true });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollWatcher, { passive: true });
  }
};
</script>

<style scoped>
/* On screens that are 600px or less, set the navbar color to black */

.navvy-normal {
  transition: 500ms;
}

.navvy {
  background-color: #2c2e2b;
}

.icon {
  font-family: AvenirNext-Heavy;
  font-size: 200%;
  margin: 0px;
  letter-spacing: -2px;
}

.company-move {
  transition: all 600ms ease-in-out 50ms;
}
.company-enter-active {
  transition: all 300ms ease-out;
}
.company-leave-active {
  transition: all 200ms ease-in;
  position: absolute;
  z-index: 0;
}
.company-enter,
.company-leave-to {
  opacity: 0;
}
.company-enter {
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar/NavBar.vue